import { Link } from "react-router-dom";

export default function ScrollAfterArticle({ visibleSlides }) {
  return (
    <div className="scroll">
      <div className="info-box-wrapper-mobile">
        {visibleSlides.map((item, index) => {
          return (
            <div className="review-box" key={index}>
              <Link to={`/blog/${item.text.split(" ").join("-")}`}>
                <div className="d-block popular-article-image">
                  <img src={item.image} alt={item.text} />
                </div>
                <div className="popular-article-text">{item.text}</div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
